module.exports = __webpack_public_path__ + "img/green_013.ec4ceddf.png";